import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { hooks } from 'botframework-webchat'
import { IconButton, useToast } from '@totalsoft/rocket-ui'
import { LocationOn as LocationIcon } from '@mui/icons-material'

import { SEND_USER_LOCATION } from 'constants/webchat/activityNames'

const SendLocationButton = () => {
  const { t } = useTranslation()
  const sendToast = useToast()
  const postActivity = hooks.usePostActivity()
  const [disabled] = hooks.useDisabled()

  const shareLocation = useCallback(() => {
    if (!('geolocation' in navigator)) {
      sendToast(t('Chatbot.Location.LocationNotSupported'), 'error')
      return
    }

    navigator.geolocation.getCurrentPosition(
      pos => {
        const { latitude, longitude, accuracy, altitude, altitudeAccuracy, heading, speed } = pos.coords

        postActivity({
          type: 'message',
          name: SEND_USER_LOCATION,
          value: {
            latitude,
            longitude,
            accuracy,
            altitude,
            altitudeAccuracy,
            heading,
            speed
          }
        })
        sendToast(t('Chatbot.Location.LocationSent'), 'success')
      },
      err => {
        console.error('Geolocation error:', err)
        sendToast(t('Chatbot.Location.LocationFailedToSend'), 'error')
      },
      {
        enableHighAccuracy: true,
        maximumAge: 15_000,
        timeout: 10_000
      }
    )
  }, [postActivity, sendToast, t])

  return (
    <IconButton
      color='transparent'
      onClick={shareLocation}
      disabled={disabled}
      aria-label='Send location'
      title={t('Chatbot.Location.SendLocation')}
      style={{ borderRadius: 0 }} // Ensures the button has no border radius for consistency with Fluent UI design
    >
      <LocationIcon />
    </IconButton>
  )
}

export default SendLocationButton
